module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1517-bbf75825769c086c3e5d95b0e3e77c89.png";